function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "person-24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Contact-Notes-&-History",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ADv2_ContactNotes_Recognised-Caller",
  transform: "translate(-848.000000, -283.000000)",
  fill: "#001529",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(821.000000, 249.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(24.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "person-24px",
  transform: "translate(3.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7,7 C8.84166667,7 10.3333333,5.50833333 10.3333333,3.66666667 C10.3333333,1.825 8.84166667,0.333333333 7,0.333333333 C5.15833333,0.333333333 3.66666667,1.825 3.66666667,3.66666667 C3.66666667,5.50833333 5.15833333,7 7,7 Z M7,8.66666667 C4.775,8.66666667 0.333333333,9.78333333 0.333333333,12 L0.333333333,13.6666667 L13.6666667,13.6666667 L13.6666667,12 C13.6666667,9.78333333 9.225,8.66666667 7,8.66666667 Z",
  id: "Shape"
}))))));

var SvgContactName = function SvgContactName(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactName, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact_name.c54bd331.svg";
export { ForwardRef as ReactComponent };